import { gspx } from '@rsos/gainsight';

export const trackClickViewMore = irpVersion => {
  gspx.trackCustomEvent('Ellington', {
    irpVersion,
    name: `Click View More button`,
    Category: 'Ellington',
    'Launched date': new Date(),
  });
};

export const trackToggleVideoPlay = (id, irpVersion) => {
  gspx.trackCustomEvent('Ellington', {
    irpVersion,
    name: `Play Media ${id}`,
    Category: 'Ellington',
    'Launched date': new Date(),
  });
};

export const trackToggleVideoPause = (id, irpVersion) => {
  gspx.trackCustomEvent('Ellington', {
    irpVersion,
    name: `Pause Media ${id}`,
    Category: 'Ellington',
    'Launched date': new Date(),
  });
};

export const trackVideoError = (id, irpVersion) => {
  gspx.trackCustomEvent('Ellington', {
    irpVersion,
    name: `Media Error ${id}`,
    Category: 'Ellington',
    'Launched date': new Date(),
  });
};

export const trackVideoLoadedData = (id, irpVersion) => {
  gspx.trackCustomEvent('Ellington', {
    irpVersion,
    name: `Loaded Media Data ${id}`,
    Category: 'Ellington',
    'Launched date': new Date(),
  });
};

export const trackVideoLoadStart = (id, irpVersion) => {
  gspx.trackCustomEvent('Ellington', {
    irpVersion,
    name: `Load Media Start ${id}`,
    Category: 'Ellington',
    'Launched date': new Date(),
  });
};
